import { Grid } from '@mui/material';
import { LoadingIndicator } from '../LoadingIndicator';

interface SectionTitleProps {
  title: string;
  loadingPercentage: number;
}

const SectionTitle = ({ loadingPercentage, title }: SectionTitleProps) => {
  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
      <Grid item xs={6}>
        <h2>{title}</h2>
      </Grid>
      <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }} item xs={6}>
        <LoadingIndicator
          loadingPercentage={loadingPercentage}
          showLoadingText={true}
        />
      </Grid>
    </Grid>
  );
};
export default SectionTitle;
